import React from 'react';
import {
    Dialog,
    DialogContent,
    Button,
    Table,
    DialogTitle,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper, // Add Paper import
} from '@mui/material';
import LineGraph from './LineGraph'; // Adjust the path as needed

const DialogBox = ({
    isOpen, onClose, title, activities, isTableVisible, isLineGraphVisible, toggleTable, toggleLineGraph, setTableVisible, setLineGraphVisible,
}) => {


    const getMonthName = (month) => {
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December',
        ];
        return monthNames[month - 1]; // Months are zero-indexed
    };


    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>{ title }</DialogTitle>
            <DialogContent>
                <div className="section-toggle">
                    <Button onClick={() => { toggleTable(); setTableVisible(true); setLineGraphVisible(false); }} variant="contained" color="primary" style={{ marginRight: '10px' }}>
                        Table
                    </Button>
                    <Button onClick={() => { toggleLineGraph(); setLineGraphVisible(true); setTableVisible(false); }} variant="contained" color="primary">
                        Line Graph
                    </Button>

                </div>

                { isTableVisible && (
                    <div className="section">
                        <TableContainer component={Paper} style={{ maxHeight: '600px', overflow: 'auto' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="sticky-header">Year</TableCell>
                                        <TableCell className="sticky-header">Month</TableCell>
                                        <TableCell className="sticky-header">Monthly Count</TableCell>
                                        <TableCell className="sticky-header">Cumulative Count</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { activities.map((activity, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{ activity.year }</TableCell>
                                            <TableCell>{ getMonthName(activity.month) }</TableCell>
                                            <TableCell>{ activity.monthly_count }</TableCell>
                                            <TableCell>{ activity.cumulative_count }</TableCell>
                                        </TableRow>
                                    )) }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                ) }{ isLineGraphVisible && (
                    <div className="section">
                        <LineGraph
                            labels={activities.map(activity => `${getMonthName(activity.month)} ${activity.year}`)}
                            data={activities.map(activity => activity.cumulative_count)}
                            label="Cumulative Count"
                            yAxisLabel="Cumulative Count"
                        />
                    </div>
                ) }


            </DialogContent>
            <style>
                { `
          .section-toggle {
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
          }

          .section {
            flex: 1;
            margin-right: 20px;
            overflow: auto;
          }

          .sticky-header {
            font-weight: bold;
            position: sticky;
            top: 0;
            background-color: #f0f0f0;
            z-index: 1;
          }
        ` }
            </style>
        </Dialog>
    );
};

export default DialogBox;
